import { axios } from '@/utils/request'
const api = "/Shop"
export default {
  upload: (parameter) => {
    return axios({
      url: `${api}/upload`,
      method: 'post',
      data: parameter
    })
  },
  ShopDrawlist: (parameter) => {
    return axios({
      url: `${api}/ShopDrawlist`,
      method: 'post',
      data: parameter
    })
  },
  ShopTong: (parameter) => {
    return axios({
      url: `${api}/ShopTong`,
      method: 'post',
      data: parameter
    })
  },
  ShopJue: (parameter) => {
    return axios({
      url: `${api}/ShopJue`,
      method: 'post',
      data: parameter
    })
  },
  ShopList: (parameter) => {
    return axios({
      url: `${api}/ShopList`,
      method: 'post',
      data: parameter
    })
  },
  AreaList: (parameter) => {
    return axios({
      url: `${api}/AreaList`,
      method: 'post',
      data: parameter
    })
  },
  AddShop: (parameter) => {
    return axios({
      url: `${api}/AddShop`,
      method: 'post',
      data: parameter
    })
  },
  FindShop: (parameter) => {
    return axios({
      url: `${api}/FindShop`,
      method: 'post',
      data: parameter
    })
  },
  SaveShop: (parameter) => {
    return axios({
      url: `${api}/SaveShop`,
      method: 'post',
      data: parameter
    })
  },
  DeleteShop: (parameter) => {
    return axios({
      url: `${api}/DeleteShop`,
      method: 'post',
      data: parameter
    })
  },
  Findprovider: (parameter) => {
    return axios({
      url: `${api}/Findprovider`,
      method: 'post',
      data: parameter
    })
  },
  Saveprovider: (parameter) => {
    return axios({
      url: `${api}/Saveprovider`,
      method: 'post',
      data: parameter
    })
  },
  Addprovider: (parameter) => {
    return axios({
      url: `${api}/Addprovider`,
      method: 'post',
      data: parameter
    })
  },
  Deleteprovider: (parameter) => {
    return axios({
      url: `${api}/Deleteprovider`,
      method: 'post',
      data: parameter
    })
  },

    ClearCache: (parameter) => {
        return axios({
            url: `${api}/ClearCache`,
            method: 'post',
            data: parameter
        })
    },

  providerList: (parameter) => {
    return axios({
      url: `${api}/providerList`,
      method: 'post',
      data: parameter
    })
  },

  offList: (parameter) => {
        return axios({
            url: `${api}/offList`,
            method: 'post',
            data: parameter
        })
    },
  Saveprovider: (parameter) => {
    return axios({
      url: `${api}/Saveprovider`,
      method: 'post',
      data: parameter
    })
  },

  UpdateProviderStatus: (parameter) => {
    return axios({
      url: `${api}/UpdateProviderStatus`,
      method: 'post',
      data: parameter
    })
  },


    punishList: (parameter) => {
        return axios({
            url: `${api}/punishList`,
            method: 'post',
            data: parameter
        })
    },
  recordList: (parameter) => {
    return axios({
      url: `${api}/recordList`,
      method: 'post',
      data: parameter
    })
  },
  
}